import styled from 'styled-components';

import { useConfig } from '@wecasa/common/src/providers/config-provider';
import type { WellnessBasketPrices } from '@wecasa/common/src/types/commons';
import { formatPrice } from '@wecasa/common/src/utils/formatting';

import { getBasketPrices, getPrestationCount } from '@wecasa/customer/src/ducks/basket-selectors';

import { translate } from '@wecasa/i18n';

import useHasOrWantsMembership from '@wecasa/membership/src/hooks/use-has-or-wants-membership';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';
import Label from '@wecasa/web-ui/src/components/label/label';

import { useAppSelector } from '../../../store';

const t = translate('basket.preview.membership');

const StyledWithPrestationsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const StyledNoPrestationsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 5px;
`;

const ClubLabel = styled(Label)`
  margin-left: 5px;
`;

const WellnesPreview = () => {
  const config = useConfig();
  const hasMembership = useHasOrWantsMembership();
  const prices = useAppSelector((state) => getBasketPrices(state, config)) as WellnessBasketPrices;
  const prestationCount = useAppSelector(getPrestationCount);

  return (
    <>
      {prestationCount > 0 ? (
        <StyledWithPrestationsWrapper>
          <Text>
            <Text.MDBold>{formatPrice(prices.membership.totalPrice)}</Text.MDBold>
            <ClubLabel size='sm' backgroundColor='pink20'>
              {t('.club')}
            </ClubLabel>
          </Text>
          <Text.XS strikedOut={hasMembership}>
            {t('.without_membership', { price: formatPrice(prices.totalPrice) })}
          </Text.XS>
        </StyledWithPrestationsWrapper>
      ) : (
        <StyledNoPrestationsWrapper>
          <Text.MDBold>{formatPrice(0)}</Text.MDBold>
        </StyledNoPrestationsWrapper>
      )}
    </>
  );
};

export default WellnesPreview;
